import type { ExamScheduleDto } from '../types/models';

/** Value for a <input type="datetime-local"> from an ISO string (local wall-clock). */
export function toLocalInput(iso: string): string {
  const d = new Date(iso);
  const pad = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}T${pad(d.getHours())}:${pad(d.getMinutes())}`;
}

export function defaultWindow(): { start: string; end: string } {
  const d = new Date(Date.now() + 24 * 3600 * 1000);
  const pad = (n: number) => String(n).padStart(2, '0');
  const day = `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  return { start: `${day}T09:00`, end: `${day}T12:00` };
}

export const fmtDate = (iso: string) =>
  new Date(iso).toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
export const fmtTime = (iso: string) =>
  new Date(iso).toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });

export type StatusKey = 'draft' | 'upcoming' | 'active' | 'closed' | 'partial';

export function statusOf(s: ExamScheduleDto, now: number): { key: StatusKey; label: string } {
  if (!s.isPublished) return { key: 'draft', label: 'Draft' };
  const start = new Date(s.scheduledStart).getTime();
  const end = new Date(s.scheduledEnd).getTime();
  if (now < start) return { key: 'upcoming', label: 'Upcoming' };
  if (now <= end) return { key: 'active', label: 'Active' };
  return { key: 'closed', label: 'Completed' };
}

export const STATUS_STYLE: Record<StatusKey, { bg: string; fg: string }> = {
  draft: { bg: 'var(--border)', fg: 'var(--muted)' },
  upcoming: { bg: 'var(--accent-soft-bg)', fg: 'var(--accent)' },
  active: { bg: 'var(--success-soft-bg)', fg: 'var(--success-soft-fg)' },
  closed: { bg: 'var(--border)', fg: 'var(--muted)' },
  partial: { bg: 'var(--accent-soft-bg)', fg: 'var(--accent)' },
};

export function StatusPill({ st }: { st: { key: StatusKey; label: string } }) {
  const style = STATUS_STYLE[st.key];
  return (
    <span style={{
      display: 'inline-block', padding: '3px 11px', borderRadius: 999,
      fontSize: 12, fontWeight: 600, background: style.bg, color: style.fg,
    }}>● {st.label}</span>
  );
}
